export default {
  light: {
    'brand-primary': {
      base: '#FF4800',
      darken1: '#B45F38',
      lighten1: '#FE9F72',
      lighten2: '#FFCFB9',
      lighten3: '#FFE7DC',
      lighten4: '#FEF3ED'
    },
    'brand-secondary': {
      base: '#5A35B7',
      darken1: '#3B2781',
      lighten1: '#000000',
      lighten2: '#BDAEE2',
      lighten3: '#DED7F1',
      lighten4: '#EEEBF7'
    },
    'brand-tertiary': {
      base: '#FC4B93',
      darken1: '#B33568',
      lighten1: '#FD8CBA',
      lighten2: '#FEB7D4',
      lighten3: '#FEDBE9',
      lighten4: '#FEEDF4'
    },
    'brand-quaternary': {
      base: '#0C1330',
      darken1: '#080D22',
      lighten1: '#232A44',
      lighten2: '#3C4259',
      lighten3: '#CECFD5',
      lighten4: '#E8E8EB'
    },
    'feedback-error': {
      base: '#EB3B5A',
      darken1: '#A7293F',
      lighten1: '#EE627A',
      lighten2: '#F6B0BC',
      lighten3: '#FAD7DD',
      lighten4: '#FDEBEF'
    },
    'feedback-success': {
      base: '#20BF6B',
      darken1: '#16874C',
      lighten1: '#4CCB88',
      lighten2: '#A5E5C3',
      lighten3: '#D1F2E0',
      lighten4: '#E9F9F0'
    },
    'feedback-info': {
      base: '#4B7BEC',
      darken1: '#3557A7',
      lighten1: '#6E95EF',
      lighten2: '#B6C9F7',
      lighten3: '#DAE4FB',
      lighten4: '#EDF2FD'
    },
    'feedback-warning': {
      base: '#F7B731',
      darken1: '#AF8222',
      lighten1: '#F8C55A',
      lighten2: '#FBE2AC',
      lighten3: '#FDF0D5',
      lighten4: '#FEF8EA'
    },
    'feedback-link': {
      base: '#0075FF',
      darken1: '#0053B5',
      lighten1: '#3290FF',
      lighten2: '#98C7FF',
      lighten3: '#CBE2FF',
      lighten4: '#E7F2FF'
    },
    grayscale: {
      base: '#353840',
      lighten1: '#656872',
      lighten2: '#A4A6AC',
      lighten3: '#CFCFD1',
      lighten4: '#E4E4E4',
      lighten5: '#EFEFEF',
      lighten6: '#F8F8F8'
    },
  },
  serasa: {
    'brand-primary': {
      base: '#002DD1',
      lighten1: '#4D6CDF',
      lighten2: '#B3C0F1',
      lighten3: '#E6EAFA'
    },
    'brand-secondary': {
      base: '#1E293B',
      lighten1: '#475569',
      lighten2: '#94A3B8'
    },
    'brand-tertiary': {
      base: '#1A2B4B',
      lighten1: '#1E437A',
      lighten2: '#A6AFD0'
    },
    'feedback-error': {
      base: '#FA1320',
      darken1: '#D0141A',
      lighten1: '#FFF6F3'
    },
    'feedback-success': {
      base: '#0FAC67',
      darken1: '#1B7749',
      lighten1: '#F1FBF4'
    },
    'feedback-info': {
      base: '#4D6CDF',
      darken1: '#0024A7',
      lighten1: '#F5F5FF'
    },
    'feedback-warning': {
      base: '#FFC400',
      darken1: '#E6B000',
      lighten1: '#FFF9E6'
    },
    'feedback-link': {
      base: '#F50177'
    },
    grayscale: {
      base: '#3D3D3D',
      lighten1: '#6D6D6D',
      lighten2: '#888888',
      lighten3: '#B0B0B0',
      lighten4: '#D1D1D1',
      lighten5: '#E7E7E7',
      lighten6: '#F6F6F6'
    }
  }
}
